import axios from 'axios'
import { Message } from 'element-ui'
// import { baseUrl } from '../config/config_dev'
import router from '../router'
import store from '../store'
const baseUrl = process.env.VUE_APP_BASE_URL
const wxUrl = process.env.VUE_APP_WXAPP_URL
axios.interceptors.request.use(
  (config) => {
    return config
  },
  (error) => {
    Message.error(error.message)
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    // Message.error(error.message)
    if (error.response && error.response.status === 401) {
      store.commit('account/reset')
      if (sessionStorage.getItem('open-mode')) {
        top.postMessage({ type: 'logout' }, '*')
      } else {
        router.push(`/login?redirct=${router.currentRoute.fullPath}`)
      }
    }
    return Promise.reject(error)
  }
)

const commonHeaders = {}
/**
 * @param {*} api 接口路径
 * @param {*} options 请求参数
 * @param {*} auth 是否token
 * @param {*} file 是否文件
 * @param {*} download 是否下载
 */
export const request = (api, options = {}, auth = true, file = false, download = false) => {
  const userInfo = store.state.account.userInfo
  const authHeader = auth ? { token: userInfo.token } : {}
  const fileHeader = file ? { 'Content-Type': 'multipart/form-data' } : {}
  const responseType = download ? { responseType: 'blob' } : {}

  return axios.post(baseUrl + api, options, {
    headers: { ...commonHeaders, ...authHeader, ...fileHeader },
    ...responseType
  })
}

export const request1 = (api, options = {}, auth = true, file = false, download = false) => {
  const userInfo = store.state.account.userInfo
  const authHeader = auth ? { token: userInfo.token } : {}
  const fileHeader = file ? { 'Content-Type': 'multipart/form-data' } : {}
  const responseType = download ? { responseType: 'blob' } : {}

  return axios.post(wxUrl + api, options, {
    headers: { ...commonHeaders, ...authHeader, ...fileHeader },
    ...responseType
  })
}
